import React from 'react';
import PropTypes from 'prop-types';
import { Button, Callout, Divider, Link, ProgressSteps, Text, Title, Icon } from '@homeexchange/design';

import i18n from '../../i18n';
import User from '../../models/User';
import Proptypes from 'prop-types';

export class HomeVerification extends React.PureComponent {
    static propTypes = {
        user: PropTypes.instanceOf(User).isRequired,
        showPersona: Proptypes.func.isRequired
    };

    getHomeIdFromUrl() {
        return parseInt(window.location.pathname.split('/').pop(), 10);
    }

    getHomeToVerify(homes) {
        const homeId = this.getHomeIdFromUrl();

        if (!homes || homes.length === 0) {
            return;
        }

        return homes.find((home) => home.id === homeId);
    }

    stepOne(home, isHomeQualified) {
        return (
            <div className="step-content">
                <div className="step-title">{i18n.t('user:page_verification_completeNewHome_title')}</div>

                <div className="step-info">
                    {!isHomeQualified && (
                        <>
                            <Text
                                size="sm"
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('user:page_verification_completeNewHome_desc')
                                }}
                            ></Text>

                            {home && (
                                <>
                                    <Divider space="small" />
                                    <Text>{home.get('address')}</Text>
                                    <Divider space="small" />
                                </>
                            )}

                            <Button
                                className="step-one-complete-home"
                                onClick={() => (location.href = i18n.t('url:home_edit', { id: home.id }))}
                            >
                                {i18n.t('user:page_verification_completeNewHome_title')}
                            </Button>
                        </>
                    )}
                </div>
            </div>
        );
    }

    componentDidMount() {
        this.checkAndRedirect();
    }

    componentDidUpdate() {
        this.checkAndRedirect();
    }

    checkAndRedirect() {
        const { user } = this.props;
        if (!user) {
            return;
        }

        const home = this.getHomeToVerify(user.get('homes'));
        if (home && home.isVerified()) {
            window.location.href = i18n.t('user:user.verif.url');
        }
    }

    stepTwo(home, isDisabled) {
        const { user, showPersona } = this.props;

        return (
            <div className="step-content">
                <div className="step-title">{i18n.t('user:page_verification_verifDocs_newHome_title')}</div>
                <div className="step-info">
                    {!user.isPending() && (
                        <>
                            <Text
                                size="sm"
                                dangerouslySetInnerHTML={{
                                    __html: i18n.t('user:page_verification_verifDocs_newHome_desc')
                                }}
                            ></Text>

                            {home && (
                                <>
                                    <Divider space="small" />
                                    <Text>{home.get('address')}</Text>
                                    <Divider space="small" />
                                </>
                            )}

                            {home?.isOffline() && (
                                <Callout status="warning">
                                    <Text
                                        dangerouslySetInnerHTML={{
                                            __html: i18n.t(
                                                'user:page_verification_verifDocs_offlineCallout_body'
                                            )
                                        }}
                                    />
                                    <Link href={i18n.t('url:home_edit', { id: home.id })}>
                                        {i18n.t('user:page_verification_verifDocs_offlineCallout_link')}
                                    </Link>
                                </Callout>
                            )}

                            <Button
                                className="button-step"
                                type="button"
                                onClick={showPersona}
                                isDisabled={isDisabled || home?.isOffline()}
                            >
                                {i18n.t('user:global_verifyDocuments')}
                            </Button>
                        </>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { user } = this.props;

        if (!user) {
            return;
        }

        const home = this.getHomeToVerify(user.get('homes'));
        if (!home) {
            return;
        }

        const isHomeQualified = home.get('completion_rate') >= User.ENOUGH_COMPLETION_RATE;

        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-7">
                        <div className="verification-title">
                            <Title isImpact={true} hasHeaderTag={true} level={2}>
                                {i18n.t('user:page.verifPage.newHome.title')}
                            </Title>
                        </div>

                        <Text className="verification-desc" size="md">
                            {i18n.t('user:page_verification_subheader')}
                        </Text>

                        <div className="verification-faq">
                            <Link color="secondary" target="_blank" href={i18n.t('url:url.pending_faq')}>
                                {i18n.t('user:verify_account.faq_text')}
                            </Link>
                            <Icon name="ArrowUpRightSquare" />
                        </div>

                        <div className="verification-steps">
                            <ProgressSteps
                                className="progress-steps"
                                orientation="vertical"
                                steps={[
                                    {
                                        icon: isHomeQualified && 'CheckCircleFill',
                                        iconColor: 'success',
                                        content: this.stepOne(home, isHomeQualified),
                                        isDone: isHomeQualified
                                    },
                                    {
                                        content: this.stepTwo(home, !isHomeQualified),
                                        isDisabled: !isHomeQualified
                                    }
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default HomeVerification;
